<template>
  <div class="sidebar-logo-container" :class="{'collapse': collapse}" :style="{ backgroundColor: settings.sideTheme === 'theme-dark' ? variable.sidebarLogoBackground : variable.menuLightBackground }">
    <transition name="sidebarLogoFade">
      <router-link to="/home" key="collapse" class="sidebar-logo-link" v-if="collapse">
        <img :src="logoIcon" alt="" class="sidebar-logo"/>
      </router-link>
      <router-link to="/home" key="expand" class="sidebar-logo-link" v-else>
        <img :src="logo" alt="LabelCheap" class="sidebar-logo is-full"/>
      </router-link>
    </transition>
  </div>
</template>

<script>
import variable from '../../style/scss/variable.scss'
import logoImage from '../../assets/images/logo.png'
import logoIconImage from '../../assets/images/logo-icon.png'
import { mapState } from 'vuex'

export default {
  name: 'Logo',
  props: {
    // 是否折叠
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      // logo路径（展开：横版完整logo；折叠：方形图标）
      logo: logoImage,
      logoIcon: logoIconImage
    }
  },
  computed: {
    ...mapState(['settings']),
    // scss样式
    variable () {
      return variable
    }
  },
  mounted () {

  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid rgba(206, 238, 230, .12);
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;

      // 展开状态：横版完整 logo，按高度等比缩放，避免被压扁
      &.is-full {
        width: auto;
        height: 30px;
        max-width: 150px;
        margin-right: 0;
        object-fit: contain;
      }
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
